import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anim',
  templateUrl: './anim.component.html',
  styleUrls: ['./anim.component.scss']
})
export class AnimComponent implements OnInit {

  equipe = [
    {nom: 'coco MiamMiam'},
    {nom: 'Papa charlie'},
    {nom: 'Speedy'},
    {nom: 'Kevis'},
    {nom: 'Stephan'}
  ];
  anim = [
    {nom: 'Cazae'},
    {nom: 'Yakari'},
    {nom: 'Nono le petit robot'},
    {nom: 'Pedro'},
    {nom: 'Magnum'},
    {nom: 'Milou Spatial'}
  ];

  constructor() { }

  ngOnInit() {
  }

}
